import { workerService } from '@/services';
import { vuexEventPathGenerator } from '@/utils';
import WorkerVM from '@/view-model/worker-management/WorkerVM';
import { AxiosError } from 'axios';
import { mutationType } from './mutations';
export const actionType = {
    resetWorkerDetail: 'resetWorkerDetail',
    getWorkerDetail: 'getWorkerDetail',
    putWorkerDetail: 'putWorkerDetail',
};
export const workerEditActionType = vuexEventPathGenerator(actionType, 'workerManagement/workerEdit');
const action = {
    [actionType.resetWorkerDetail]({ commit }) {
        commit(mutationType.RESET_WORKER_DETAIL);
    },
    async [actionType.getWorkerDetail]({ commit }, code) {
        const response = await workerService.getWorker({
            workerCode: code,
        });
        const res = new WorkerVM(response.data);
        commit(mutationType.GET_WORKER_DETAIL, res);
    },
    async [actionType.putWorkerDetail]({ commit }, data) {
        try {
            const response = await workerService.putWorkerDetail(data);
            const res = new WorkerVM(response.data);
            commit(mutationType.UPDATE_DETAIL, res);
            return {
                isSuccess: true,
            };
        }
        catch (error) {
            if (error instanceof AxiosError) {
                const message = error.response?.data.error.message ?? error.message;
                const reason = error.response?.data.error.reason ?? error.reason;
                return {
                    isSuccess: false,
                    reason,
                    message,
                };
            }
        }
        return false;
    },
};
export default action;
